// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   Input,
//   InputNumber,
//   Button,
//   Select,
//   Row,
//   Col,
//   Typography,
//   message,
// } from "antd";
// import { createServiceApi } from "../../services/serviceApi";
// import { toast } from "react-toastify";
// import { useParams } from "react-router-dom";
// // import { createServiceApi } from "../services/service";
// // import { getAllTenantsApi } from "../services/tenant";
// // import { getAllCompaniesApi } from "../services/company";

// const { Title } = Typography;

// export default function CreateServicePage() {
//   const [form] = Form.useForm();
//   const [tenants, setTenants] = useState([]);
//   const [companies, setCompanies] = useState([]);
//   const [images, setImages] = useState([]);
//   const { tenantId } = useParams();
//   console.log(tenantId,"tenantId")
//   // Fetch tenants and companies on load
// //   useEffect(() => {
// //     fetchTenants();
// //     fetchCompanies();
// //   }, []);

// //   const fetchTenants = async () => {
// //     try {
// //       const res = await getAllTenantsApi();
// //       setTenants(res || []);
// //     } catch (err) {
// //       message.error("Failed to load tenants");
// //     }
// //   };

// //   const fetchCompanies = async () => {
// //     try {
// //       const res = await getAllCompaniesApi();
// //       setCompanies(res || []);
// //     } catch (err) {
// //       message.error("Failed to load companies");
// //     }
// //   };

//   const handleImageAdd = (value) => {
//     if (value) {
//       const updated = [...images, value];
//       setImages(updated);
//       form.setFieldValue("images", updated);
//     }
//   };

//   const onFinish = async (values) => {
//     try {
//       const payload = {
//         ...values,
//         tenantId:tenantId,
//         images,
//       };
//       const res = await createServiceApi(payload);
//       if(!res?.sucess) return toast.error(res?.message||'something went wrong try again')
//       toast.success("Service created successfully!");
//       form.resetFields();
//       setImages([]);
//     } catch (err) {
//       console.error(err);
//       toast.error("Service creation failed");
//     }
//   };

//   return (
//     <div style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
//       <Title level={3}>Create Service</Title>

//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={onFinish}
//         initialValues={{ commissionAmount: 0 }}
//       >
//         <Row gutter={16}>
//           <Col xs={24} md={12}>
//             <Form.Item
//               label="Service Name"
//               name="name"
//               rules={[{ required: true, message: "Please enter service name" }]}
//             >
//               <Input placeholder="Enter service name" />
//             </Form.Item>
//           </Col>

//           <Col xs={24} md={12}>
//             <Form.Item
//               label="Price"
//               name="price"
//               rules={[{ required: true, message: "Please enter price" }]}
//             >
//               <InputNumber
//                 style={{ width: "100%" }}
//                 min={0}
//                 placeholder="Enter price"
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={24} md={12}>
//             <Form.Item
//               label="Commission Amount"
//               name="commissionAmount"
//               rules={[{ required: true, message: "Please enter commission" }]}
//             >
//               <InputNumber
//                 style={{ width: "100%" }}
//                 min={0}
//                 placeholder="Enter commission"
//               />
//             </Form.Item>
//           </Col>

//           {/* <Col xs={24} md={12}>
//             <Form.Item
//               label="Tenant"
//               name={["tenant", "id"]}
//               rules={[{ required: true, message: "Please select tenant" }]}
//             >
//               <Select
//                 placeholder="Select tenant"
//                 onChange={(val) => {
//                   const selected = tenants.find((t) => t._id === val);
//                   form.setFieldValue("tenant.name", selected?.name || "");
//                 }}
//               >
//                 {tenants.map((tenant) => (
//                   <Select.Option key={tenant._id} value={tenant._id}>
//                     {tenant.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//             <Form.Item name={["tenant", "name"]} hidden>
//               <Input />
//             </Form.Item>
//           </Col> */}

//           {/* <Col xs={24} md={12}>
//             <Form.Item
//               label="Company"
//               name={["company", "id"]}
//               rules={[{ required: true, message: "Please select company" }]}
//             >
//               <Select
//                 placeholder="Select company"
//                 onChange={(val) => {
//                   const selected = companies.find((c) => c._id === val);
//                   form.setFieldValue("company.name", selected?.name || "");
//                 }}
//               >
//                 {companies.map((company) => (
//                   <Select.Option key={company._id} value={company._id}>
//                     {company.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//             <Form.Item name={["company", "name"]} hidden>
//               <Input />
//             </Form.Item>
//           </Col> */}

//           {/* <Col xs={24}>
//             <Form.Item label="Add Image URLs">
//               <Input.Search
//                 placeholder="Enter image URL and press Add"
//                 enterButton="Add"
//                 onSearch={handleImageAdd}
//               />
//               <ul style={{ paddingLeft: 16, marginTop: 8 }}>
//                 {images.map((img, idx) => (
//                   <li key={idx} style={{ fontSize: 12 }}>{img}</li>
//                 ))}
//               </ul>
//             </Form.Item>
//           </Col> */}
//         </Row>

//         <Form.Item>
//           <Button type="primary" htmlType="submit">
//             Create Service
//           </Button>
//         </Form.Item>
//       </Form>
//     </div>
//   );
// }

import React, { useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Upload,
  Card,
  Row,
  Col,
  Typography,
  message,
  Space,
  Divider,
} from "antd";
import {
  UploadOutlined,
  DollarOutlined,
  DeleteOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { createServiceApi } from "../../services/serviceApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
// import { useParams } from "react-router-dom"; // Uncomment when using real routing

const { Title, Text } = Typography;



export default function CreateServicePage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");

  // Mock tenantId - replace with actual useParams hook
  const { tenantId,companyId } = useParams();
  // const tenantId = "tenant123";

  const beforeUpload = (file) => {
    const isValidType = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"].includes(file.type);
    if (!isValidType) {
      message.error("Please upload a valid image file (JPEG, PNG, GIF, WebP)");
      return false;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image size must be less than 5MB!");
      return false;
    }

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);

    setImageFile(file);
    return false; // Prevent automatic upload
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview("");
    form.setFieldValue("image", null);
  };

  const onFinish = async (values) => {
    setLoading(true);

    try {
      // Create FormData for multipart/form-data upload
      const formData = new FormData();
      
      // Add form fields
      formData.append('name', values.name);
      formData.append('price', values.price);
      // formData.append('commissionAmount', values.commissionAmount || 0);
      formData.append('companyId', companyId);
      
      // Add image file if present (your backend expects field name 'image')
      if (imageFile) {
        formData.append('image', imageFile); // This matches your uploadImageToS3('image') field name
      }

      // Debug: Log FormData contents (remove in production)
      console.log('FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const res = await createServiceApi(formData);
      
      if (!res?.sucess) {
        toast.error(res?.message || res?.error || 'Something went wrong, try again');
        return;
      }

      toast.success("Service created successfully!");
      
      // Reset form and image
      form.resetFields();
      setImageFile(null);
      setImagePreview("");

    } catch (err) {
      console.error('Service creation error:', err);
      message.error("Service creation failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const uploadButton = (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <PlusOutlined style={{ fontSize: '24px', color: '#8c8c8c', marginBottom: '8px' }} />
      <div style={{ marginTop: 8, color: '#8c8c8c' }}>
        <div>Upload Image</div>
        <div style={{ fontSize: '12px', marginTop: '4px' }}>
          PNG, JPG, GIF up to 5MB
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '24px 16px'
    }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Title level={1} style={{ 
            background: 'linear-gradient(45deg, #1890ff, #722ed1)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '8px'
          }}>
            Create New Service
          </Title>
          <Text type="secondary" style={{ fontSize: '16px' }}>
            Fill in the details to create a new service offering
          </Text>
        </div>

        {/* Main Form Card */}
        <Card
          style={{
            borderRadius: '16px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
            border: 'none'
          }}
          bodyStyle={{ padding: '40px' }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ commissionAmount: 0 }}
            size="large"
          >
            {/* Service Details Section */}
            <div style={{ marginBottom: '32px' }}>
              <Title level={3} style={{ 
                color: '#1890ff', 
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <DollarOutlined style={{ marginRight: '8px' }} />
                Service Details
              </Title>

              <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={<Text strong>Service Name</Text>}
                    name="name"
                    rules={[
                      { required: true, message: "Please enter service name" },
                      { min: 2, message: "Service name must be at least 2 characters" }
                    ]}
                  >
                    <Input 
                      placeholder="Enter service name"
                      style={{ borderRadius: '8px' }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label={<Text strong>Price</Text>}
                    name="price"
                    rules={[
                      { required: true, message: "Please enter price" },
                      { type: 'number', min: 0.01, message: "Price must be greater than 0" }
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", borderRadius: '8px' }}
                      min={0}
                      step={0.01}
                      placeholder="0.00"
                      prefix="₹"
                      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} md={12}>
                  <Form.Item
                    label={<Text strong>Commission Amount</Text>}
                    name="commissionAmount"
                    tooltip="Optional commission amount for this service"
                  >
                    <InputNumber
                      style={{ width: "100%", borderRadius: '8px' }}
                      min={0}
                      step={0.01}
                      placeholder="0.00"
                      prefix="$"
                      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    />
                  </Form.Item>
                </Col> */}
              </Row>
            </div>

            <Divider />

            {/* Image Upload Section */}
            <div style={{ marginBottom: '32px' }}>
              <Title level={3} style={{ 
                color: '#1890ff', 
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <UploadOutlined style={{ marginRight: '8px' }} />
                Service Image
              </Title>

              <Form.Item
                label={<Text strong>Upload Image (Optional)</Text>}
                name="image"
                extra="Maximum file size: 5MB. Supported formats: JPEG, PNG, GIF, WebP"
              >
                {!imagePreview ? (
                  <Upload
                    beforeUpload={beforeUpload}
                    showUploadList={false}
                    accept="image/*"
                  >
                    <div style={{
                      border: '2px dashed #d9d9d9',
                      borderRadius: '12px',
                      padding: '40px 20px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s',
                      ':hover': {
                        borderColor: '#1890ff'
                      }
                    }}
                    onMouseEnter={(e) => e.target.style.borderColor = '#1890ff'}
                    onMouseLeave={(e) => e.target.style.borderColor = '#d9d9d9'}
                    >
                      {uploadButton}
                    </div>
                  </Upload>
                ) : (
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <div style={{
                      border: '2px solid #f0f0f0',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      position: 'relative'
                    }}>
                      <img
                        src={imagePreview}
                        alt="Service preview"
                        style={{
                          width: '300px',
                          height: '200px',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                      />
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px'
                      }}>
                        <Button
                          type="primary"
                          danger
                          shape="circle"
                          icon={<DeleteOutlined />}
                          size="small"
                          onClick={handleRemoveImage}
                        />
                      </div>
                    </div>
                    {imageFile && (
                      <div style={{ marginTop: '8px', textAlign: 'center' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                          {imageFile.name} ({(imageFile.size / 1024 / 1024).toFixed(2)} MB)
                        </Text>
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>
            </div>

            <Divider />

            {/* Submit Section */}
            <div style={{ textAlign: 'right', paddingTop: '16px' }}>
              <Space size="middle">
                <Button 
                  size="large" 
                  onClick={() => {
                    form.resetFields();
                    setImageFile(null);
                    setImagePreview("");
                  }}
                  style={{ borderRadius: '8px' }}
                >
                  Reset Form
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  size="large"
                  style={{ 
                    borderRadius: '8px',
                    background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                    border: 'none',
                    minWidth: '120px'
                  }}
                  icon={loading ? <LoadingOutlined /> : <PlusOutlined />}
                >
                  {loading ? 'Creating...' : 'Create Service'}
                </Button>
              </Space>
            </div>
          </Form>
        </Card>
      </div>
    </div>
  );
}